import { useEffect } from 'react';
import { useSEO, getOrganizationSchema, getWebPageSchema, getServiceSchema, getFAQSchema } from '../../utils/seo';
import Navbar from '../../components/feature/Navbar';
import Hero from './components/Hero';
import PainPoints from './components/PainPoints';
import Solution from './components/Solution';
import HowWeWork from './components/HowWeWork';
import Services from './components/Services';
import CaseStudies from './components/CaseStudies';
import WhyUs from './components/WhyUs';
import Results from './components/Results';
import About from './components/About';
import LeadForm from './components/LeadForm';
import Footer from './components/Footer';

export default function EnglishPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // SEO Configuration for English version
  const combinedSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      getOrganizationSchema(),
      getWebPageSchema(
        'Systematic Marketing and AI Technologies Agency',
        'Systematic marketing and AI technologies for stable sales growth. We turn chaos into a system. Comprehensive solutions for business scaling using artificial intelligence and end-to-end analytics.',
        'SITE_URL/en'
      ),
      getServiceSchema(),
      getFAQSchema()
    ]
  };

  useSEO({
    title: 'Systematic Marketing and AI Technologies Agency',
    description: 'Systematic marketing and AI technologies for stable sales growth. We turn chaos into a system. Comprehensive solutions for business scaling using artificial intelligence and end-to-end analytics.',
    keywords: 'systematic marketing, AI marketing, contextual advertising, targeted advertising, SMM, Ozon promotion, marketing consulting, end-to-end analytics, ROMI',
    canonical: '/en',
    schema: combinedSchema
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <PainPoints />
      <Solution />
      <div id="services">
        <Services />
      </div>
      <div id="how-we-work">
        <HowWeWork />
      </div>
      <div id="cases">
        <CaseStudies />
      </div>
      <Results />
      <div id="why-us">
        <WhyUs />
      </div>
      <div id="about">
        <About />
      </div>
      <div id="team">
        {/* Team section is inside About component */}
      </div>
      <LeadForm />
      <div id="contacts">
        <Footer />
      </div>
    </div>
  );
}
